import { request } from './request';

/**
 * 获取系统配置 admin
 * @param {Object} params p
 */
export function fetchSystemText(params) {
  return request
    .post('/systemText/listSystemTexts', params)
    .then((res) => (res || [])[0]);
}

/**
 * 判断活动是否在有效期内
 */
export function fetchActivityValidTime() {
  return request.get('/activity/validTime');
}

/**
 * 获取版本的审核状态
 * @param {*} params params
 * @returns Promise
 */
export function fetchAuditStatus(params) {
  return request.post('/version/auditStatus/get', params);
}

/**
 * 绑定三维家账号和公众号
 * @param {*} params {code: 微信code, useId }
 * @returns boolean false· 未绑定，需要登录再次调用绑定，true：已绑定
 */
export function bindSwjAccount(params) {
  return request.post('/user/bindSwjAccount', params);
}

/**
 * 绑定三维家账号和公众号
 * @param {*} params {code: 微信code, useId }
 * @returns boolean false· 未绑定，需要登录再次调用绑定，true：已绑定
 */
export function isBindSwjAccount(params) {
  return request.post('/user/isBindSwjAccount', params);
}
